import Link from 'next/link'
import React, { useState } from 'react'
import CollectionGrid from './collection-grid'
import CollectionHeroes from './collection-heroes'
import CollectionTiledImages from './collection-tiled-images'

const CollectionPreview = ({ data }) => {
  let collectionComponent

  if (data.collection.products.length === 0) {
    return null
  }

  switch (data.layout) {
    case 'grid':
      collectionComponent = (
        <CollectionGrid
          products={data.collection.products}
          hidePagination
          paginationLimit={data.maxAmount}
        />
      )
      break
    case 'heroes':
      collectionComponent = (
        <CollectionHeroes
          products={data.collection.products}
          hidePagination
          paginationLimit={data.maxAmount}
        />
      )
      break
    case 'tiledImages':
      collectionComponent = (
        <CollectionTiledImages
          products={data.collection.products}
          hidePagination
          paginationLimit={data.maxAmount}
        />
      )
      break
    default:
      collectionComponent = (
        <CollectionHeroes
          products={data.collection.products}
          hidePagination
          paginationLimit={data.maxAmount}
        />
      )
  }

  return (
    <>
      {collectionComponent}
      <div className="container mx-auto text-center">
        <Link href={`/shop/${data.collection.slug.current}`}>
          <a className="btn mt-0 mb-10">さらに見る→</a>
        </Link>
      </div>
    </>
  )
}

export default CollectionPreview
